/**
 * RightChoice accreditation trio — G+, ACE, ATM.
 * Official logos + verbatim copy from Allied Genetic Resources / Top Genomics LLC.
 */
export default function RightMateSection() {
  const items = [
    {
      logo: "gplus",
      img: "/images/AccreditedGenomicPlus_LOGOweb.jpg",
      title: "Accredited Genomic Plus",
      body: "For the majority of producers who simply need consistent and balanced genetic improvement, without genomic setbacks, G+ Accredited bulls should be on your list for premium purchase. These sires will absolutely move you forward for both cost reduction and income producing traits and substantially reduce risk when compared to all other evaluation programs. It's simple, the right genes are in these bulls to help secure a profitable future and they have great EPDs to match!",
      testid: "accreditation-plus",
    },
    {
      logo: "ace",
      img: "/images/AccreditedCalvingEase_LOGOweb.jpg",
      title: "Accredited Calving Ease",
      body: "Simply find bulls with the ACE logo for third party Accredited, secure Calving Ease bulls. Though we have had tools in the past to assist in choosing heifer bulls, we've never had one nearly this effective. The reduced risk that comes with this genomic certification will simply make your decisions easier and your heifer calving season more successful. Purchase special purpose ACE bulls with confidence. They will deliver consistent and predictable calving ease.",
      testid: "accreditation-ace",
    },
    {
      logo: "atm",
      img: "/images/AccreditedTerminalMate_LOGOweb.jpg",
      title: "Accredited Terminal Mate",
      body: "Just like an ATM machine makes it simpler to access your cash, the ATM Logo highlights bulls accredited to generate extra cash income as soon as your next calf crop! These bulls are meant specifically to use only on mature cows and for the purpose of adding performance, pay weight and end product value to market.",
      testid: "accreditation-atm",
    },
  ];

  return (
    <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8 mt-14">
      {items.map((it) => (
        <article key={it.logo} data-testid={it.testid}
          className="relative border p-8 md:p-10 flex flex-col"
          style={{ borderColor: "var(--border-subtle)", background: "var(--bg-secondary)" }}>
          <div className="flex items-center gap-5 mb-6">
            <div className="w-24 h-24 md:w-28 md:h-28 shrink-0 flex items-center justify-center bg-white p-2"
              style={{ border: "1px solid var(--border-subtle)" }}>
              <img src={it.img} alt={`${it.title} logo`} className="max-w-full max-h-full object-contain" />
            </div>
            <div>
              <div className="font-display text-xl md:text-2xl leading-tight">{it.title}</div>
              <div className="eyebrow text-[10px] mt-2" style={{ color: "var(--brass-bright)" }}>
                Powered by Top Genomics
              </div>
            </div>
          </div>
          <p className="text-sm md:text-base leading-relaxed flex-1" style={{ color: "var(--text-secondary)" }}>
            {it.body}
          </p>
        </article>
      ))}
    </div>
  );
}
